import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { BaseService } from '../services/base.service';

@Component({
  selector: 'app-editor-redirect',
  templateUrl: './editor-redirect.component.html',
  styleUrls: ['./editor-redirect.component.less']
})
export class EditorRedirectComponent implements OnInit {

  constructor(private rp: BaseService, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      var url = decodeURIComponent(params['formurl']);
      this.redirectSSO(url);    
    });        
  }
  
/*   redirectSSO(url){
  
    var apiurl = environment.wgProfileHost + "/api/usersso";
    this.rp.dataPOST<any>(apiurl, null).subscribe(response=>{
      var redirecturl = environment.wgEditorHost+"/sso?token="+encodeURI(btoa(response.Token))+"&formurl="+url;
      window.location.href=redirecturl;
    });
  } */

  redirectSSO(url: string) {
    const apiurl = `${environment.wgProfileHost}/api/usersso`;
    this.rp.dataPOST<any>(apiurl, null).subscribe(response => {
        const token = encodeURIComponent(btoa(response.Token)); // Kodira token
        const encodedFormUrl = encodeURIComponent(url); // Kodira cijeli formurl
        const redirectUrl = `${environment.wgEditorHost}/sso?token=${token}&formurl=${encodedFormUrl}`;
        window.location.href = redirectUrl; // Preusmjeravanje na ispravan URL
    });
  }


}


